<template>
  <unbound-view :trainer="trainer" />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import UnboundView from '@/components/trainer/UnboundView';
import { ROUTE_TRAINER_VIEW } from '@/router/names';
import { SHARE_TRAINER } from '@/store/share/types';
import { MENU_ITEM_SHARE_APP_MESSAGE } from '@/constants/jssdk';

const { mapState } = createNamespacedHelpers('trainer');
const { mapState: mapShareState, mapActions: mapShareActions } = createNamespacedHelpers('share');

export default {
    computed: {
        ...mapState({
            trainer: state => state.trainer || {},
        }),
        ...mapShareState({
            share: 'share',
        }),
    },
    mounted() {
        const { id } = this.$route.params;
        if (this.trainer.id !== Number.parseInt(id, 10) || this.trainer.wechat_bound) {
            this.$router.replace({
                name: ROUTE_TRAINER_VIEW,
                params: {
                    id,
                },
            });
            return;
        }
        this.shareTrainer({ id })
            .then(() => {
                this.$wechat.ready()
                    .then(() => {
                        this.$wechat.shareAppMessage(this.share);
                        this.$wechat.showMenuItem(MENU_ITEM_SHARE_APP_MESSAGE);
                    });
            });
    },
    methods: {
        ...mapShareActions({
            shareTrainer: SHARE_TRAINER,
        }),
    },
    components: {
        UnboundView,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/trainer/UnboundView.vue